<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onRefresh()">
        <mat-icon aria-hidden="false" aria-label="Refresh">refresh</mat-icon>
        Refresh Sites
      </button>
      <button mat-button (click)="onAdd()">
        <mat-icon aria-hidden="false" aria-label="Add Site">add</mat-icon>
        Add Site
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input matInput placeholder="Search locations..." [(ngModel)]="filter" (ngModelChange)="onFilter($event)" />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilter('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-container *ngIf="loading; else loaded">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Locations...</p>
    </div>
  </ng-container>
  <ng-template #loaded>
    <p *ngIf="loadingDelayed" class="loading-warning">
      Loading is taking longer than expected. You can refresh and try again.
    </p>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort width="100%">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site ID</th>
        <td mat-cell *matCellDef="let item">{{ item.id }}</td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let item">{{ item.name }}</td>
      </ng-container>
      <ng-container matColumnDef="plantCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Plant Code</th>
        <td mat-cell *matCellDef="let item">{{ item.plantCode }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-flat-button color="accent" [routerLink]="['/admin/locations', item.id]">Edit</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </ng-template>
</div>
